import { CTAButton } from 'components/CTAButton/CTAButton';
import React from 'react';

import { cx } from '@emotion/css';
import { FAQsView } from '@modules/shared/FAQs/FAQsView';

import { AreasWeCover } from '../AreasWeCover';
import { ListOfServices } from '../ListOfServices';
import { PostCodes } from '../PostCodes';
import { EmergencyComponent } from '../shared/EmergencyComponent';
import { HeroComponent } from '../shared/HeroComponent';
import { ServiceItem } from '../shared/ServiceItem';
import { TitleAndDescComponent } from '../shared/TitleAndDescComponent';
import styles from './CarpetAndUpholsteryCleaning.module.scss';

export const CarpetAndUpholsteryCleaning = () => {
  return (
    <>
      <HeroComponent
        styles={styles}
        imageLink="/images/services/carpet-and-upholstery-cleaning/Carpet Cleaning.webp"
        imageAlt="deep cleaning white carpet"
        title="Upholstery & Carpet Cleaning"
      />
      <section className={styles.services}>
        <div className={styles.root}>
          <div className={styles.services_card_block}>
            <div className={styles.container}>
              <div className={styles.inner_section}>
                <TitleAndDescComponent
                  styles={styles}
                  title="Upholstery & Carpet Cleaning Service"
                  description="Top-notch upholstery and carpet cleaning services in London, ready to banish stains and dust bunnies—because nothing beats the comfort of a truly clean home!"
                />

                <CTAButton
                  title="Book a Carpet Cleaner"
                  serviceName="Carpet Cleaning"
                />

                <div
                  className={cx(
                    styles.wrap_section,
                    styles.service_content_container,
                  )}>
                  <TitleAndDescComponent
                    styles={styles}
                    subTitle="Cleaning Services"
                  />
                  <div className={styles.service_items}>
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/carpet-and-upholstery-cleaning/Puppy on Dirty Carpet.webp"
                      imgAlt="puppy on a dirty carpet"
                      title="Carpet Cleaning"
                      description="Our professional carpet cleaning service is designed to remove dirt, allergens, and stains from your carpets, restoring their appearance and extending their lifespan. With advanced techniques and equipment, we leave your carpets fresh, soft, and hygienic."
                    />
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/carpet-and-upholstery-cleaning/Upholstery Cleaning.webp"
                      imgAlt="deep cleaning white sofa"
                      title="Upholstery Cleaning"
                      description="Upholstery quickly collects dust, stains, and odours. This buildup diminishes the look and feel of your furniture.  Our upholstery cleaning offers a professional solution to refresh your sofas, chairs, and other upholstered items. With our specialised cleaning methods, we effectively remove dirt and stains, bringing back the comfort and freshness of your furniture."
                    />
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/carpet-and-upholstery-cleaning/Stain Removal.webp"
                      imgAlt="scrubbing stain off a carpet"
                      title="Stain Removal"
                      description="Stubborn stains can be a challenge to remove without damaging fabrics. Our stain removal service targets tough stains on carpets and upholstery, using safe, effective products that lift marks without harming the material. Whether it's a wine spill, pet stain, or another stubborn mark, we have the expertise to handle it."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={styles.root}>
        <EmergencyComponent
          title="Professional Carpet Cleaners Near Me"
          imageSrc="/images/services/carpet-and-upholstery-cleaning/Sofa Cleaning.webp"
          imageAlt="cleaner vacuuming a sofa"
          styles={styles}
          para1="Are your carpets and upholstery ready to impress your guests, or could they use a little love? Let us make your home inviting again."
          para2="Our professional carpet cleaning service has you covered, from deep carpet cleaning to upholstery cleaning. Specialising in stain removal, deep cleaning, our experienced team leave your carpets and furniture looking good as new! Available 7 days a week to accommodate your busy schedule."
        />
        <ListOfServices
          styles={styles}
          serrviceList={[
            { name: 'Rug Cleaning' },
            { name: 'Carpet Cleaning' },
            { name: 'Upholstery Cleaning' },
            { name: 'Stain Removal' },
          ]}
        />
        <AreasWeCover styles={styles} />
        <PostCodes
          styles={styles}
          mainPageUrl="/services/carpet-and-upholstery-cleaning"
        />
        <FAQsView title="Carpet Cleaning FAQs" faqItems={faqItems} />
      </div>
    </>
  );
};

const faqItems = [
  {
    title: 'How often should I have my carpets professionally cleaned?',
    details: `We recommend professional carpet cleaning every 6 to 12 months, depending on foot traffic, household pets, and other factors. For high-traffic areas, consider more frequent cleaning.`,
  },
  {
    title:
      'What’s the difference between steam cleaning and dry cleaning carpets?',
    details:
      'Steam cleaning uses hot water and detergent to deep clean carpets and remove dirt and allergens. Dry cleaning uses minimal moisture and specialised chemicals, making it a quicker option with less drying time.',
  },
  {
    title: 'How long does it take for carpets to dry after cleaning?',
    details: `Drying times vary based on cleaning method and carpet type. Typically, steam-cleaned carpets take 4 to 6 hours to dry.  Dry-cleaned carpets can be ready in 1 to 2 hours.`,
  },

  {
    title: 'How much does carpet and upholstery cleaning cost?',
    details: `Prices vary based on factors like room size, level of cleaning needed, and location. Request a Quote to get an estimate based on your needs.`,
  },
];
